export default "__VITE_PUBLIC_ASSET__a26f3159__"